// types
import { ArticleCategory } from '../../../../@types';
import { articleCategories } from '../../../../@types/unions';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { useNavigate, useSearchParams } from 'react-router-dom';

// mui
import { Box, Grid, Paper, Typography } from '@mui/material';

// fields
import { Select } from '../../../fields/Select/Select';

// utils
import { translateCategory } from '../../../../utils/translations';

export const Filters = () => {
	// hooks
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	// vars
	const categoryParam = searchParams.get('category') || '';
	const options = articleCategories.map((category) => ({
		label: translateCategory(category as ArticleCategory, t),
		value: category,
	}));

	// handlers
	const handleCategoryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		if (value && value !== 'all') {
			navigate(`/features?category=${value}`);
		} else {
			navigate('/features');
		}
	};

	return (
		<Paper sx={{ height: '100%', width: '100%' }}>
			<Box sx={(theme) => ({ padding: theme.spacing(2) })}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography fontWeight={700}>{t('filters')}</Typography>
					</Grid>
					<Grid item xs={12}>
						<Select
							hasSearchParam={false}
							label={t('category')}
							name="category"
							onChange={handleCategoryChange}
							options={options}
							value={categoryParam}
						/>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};
